import FindFormSimple from './find-form-simple.vue'
export default FindFormSimple